import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer

import ProductForm from '../../../components/product/ProductForm.vue'
import ProductItemForm from '../../../components/product/ProductItemForm.vue'
import ProductCartActions from '../../../components/product/ProductCartActions.vue'
import ProductCTAActions from '../../../components/product/ProductCTAActions.vue'

import MenuLeftBar from '../../../components/menuleftbar.vue'
let service = new services();

export default {
    name: 'Product',
    props: ['productItem'],
    data () {
        return {
            user: {},
            loggedIn: false,
            sellpoint: {},
            posts:{},
            post:{},
            seller_mode:false,
            can_edit: false,
            edit_mode:false,
            disable_btn: false,
            setPanel: false,
            editPostPanel: false,
            removePostPanel:false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl:"",
            loading:false,
            action_loading:false,
            copied: false,
            addNewPost: false,
            imageForm: "",
            file_info: {}
        }
    },
    components: {
        
    },
    methods: {
        redir(rlink){
            location.replace("/"+rlink)
        },
        copyLink() {
            this.$clipboard(this.siteUrl)
            this.copied = true;
        },
        mobileSideNavToggle(action){
            if(action == "open"){
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if(action == "close"){
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        
        setComponent(attr1,attr2){
            this.setPanel = true;
            
            if(attr1 == 'add-new-post'){
                this.addNewPost = true;
            }
            if(attr1 == 'edit-post'){
                this.editPostPanel = true;
            }
            if(attr1 == 'remove-post'){
                this.removePostPanel = true;
            }

            ////
            if(attr1 == 'add-product-item'){
                this.addProductItemPanel = true;
            }
            if(attr1 == 'edit-product-item'){
                this.editProductItemPanel = true;
            }
            if(attr1 == 'set-edit-product-item'){
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if(attr1 == 'remove-product-item'){
                this.removeItemPanel = true;
            }
            if(attr1 == 'edit-product-detail'){
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if(attr1 == 'edit-product-delivery'){
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if(attr1 == 'add-delivery-option'){
                this.addDeliveryInformation = true;
            }
            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
            }
            if(attr1 == 'set-product-item'){
                this.product_item = attr2;
            }
            if(attr1 == 'set-product-display-image'){
                this.product_display_image = attr2;
            }
            if(attr1 == 'set-descr'){
               // console.log(location.href);
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails',''));
               // location.replace(location.href.replace('#productDetails',''))
                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if(attr1 == 'set-reviews'){
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails','')); //refresh url to allow next click
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if(attr1 == 'set-information'){
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if(attr1 == 'set-discount'){
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if(attr1 == 'edit-discount'){
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if(attr1 == 'reset-edit'){
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removePostPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false
            }
        },

        setComponentActions(attr1,attr2){
            if(attr1 == 'reset-edit'){
                this.details = {};
            }
            
        },

        
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                      let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            // this.sellpoint.business_id = this.post.post_point_id;
                            //set seller options
                            this.is_editing();
                            //loggedIn options
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

        is_editing(){ //preseting if seller
            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            }
            service.can_edit(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.seller_mode = true;  //important
                    this.edit_mode =  true;
                    this.can_edit = true;
                }else {
                    this.edit_mode =  false;
                    this.seller_mode = false;  //important
                }
            }).catch((err) => {
                if(err) {
                    //log error
                }
            })
        },

        switchMode(){
            if(this.edit_mode == false){
                this.is_editing(); //revalidate seller
            }else{
                this.edit_mode = false;
                this.can_edit = true;
            }
        },

        checkIfVideo(url){
            // return filename.split('.').pop();
            let ext = url.split('.').pop();
            if(service.video_exts.includes(ext)){
                return true;
            }else{
                return false;
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setPost(){
            this.loading = true;
            service.getPostSearch(this, this.$route.params.idpos).then(response => {
                if(response.body.status == 200) {
                    this.post = response.body.data;
                    this.sellpoint.business_id = this.post.post_point_id;
                   // this.display_post = this.gallery.gallery_posts_group_posts[0];
                    this.getPosts();
                    this.preset();
                    this.loading = false;
                }
            }).catch((err) => {
                //console.log(err)
            
            })
        },

        getPosts(){
            service.getPointPosts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) { 
                    this.posts = response.body.data;
                }
            }).catch((err) => {})
                
        },

        editPost(){
            // this.disable_btn = true;
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                post_title: this.post.post_title || "nill",
                post_text: this.post.post_text,
                post_point: this.sellpoint.business_id,
            }
            
            let navi = this.$router;
            if(credentials.post_title != undefined) {
                service.editPost(this, this.post.post_id, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Post Edited", 'Success!');
                        //log user in
                        this.post = data.body.data;
                    
                        this.deactivate_processing();
                        this.editPostPanel =  false;
                    }else{
                        this.deactivate_processing();
                        this.editPostPanel =  false;
                    }
                }).catch((err) => {
                    if(err) {
                        this.deactivate_processing();
                        this.editPostPanel =  false;
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                        // this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
                this.deactivate_processing();
            }
        },

        removePost(){
            this.activate_processing();
            let navi = this.$router;
            service.deletePost(this, this.post.post_id).then(function(data) {
                if(data.body.status == 200) {
                   //return to sellpoint
                   navi.push('/'+this.$route.params.id); //go to sellpoint
                }else{
                    toastr.warning("Something went wrong", 'Warning!'); 
                    this.deactivate_processing();
                    this.removePostPanel =  false;
                }
            }).catch((err) => {
                if(err) {
                    this.deactivate_processing();
                    this.removePostPanel =  false;
                    toastr.warning("Something went wrong", 'Warning!'); 
                   // console.log(err)
                    // this.disable_btn = false;
                }
            })
        },

   
        deletePostImage(image){
            var payload = {
                data_type: "posts",
            }
            service.deleteImages(this, image, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.setPost();
                }
            }).catch((err) => {})
        },

       

        //uploads
        onFileChange(e,type,data_id) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', "default_post_media");  
                
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "posts"){
                            this.setPost();
                           
                        }
                    }
                }).catch((err) => {
                    if(err) {
                        // log it
                    }
                })
            }   
                
        },
        

},
mounted:function(){
    var top = document.getElementById("wrap").offsetTop; 
    window.scrollTo(0, top); 
},
created: function(){
   
   this.setPost();

},

}


// WEBPACK FOOTER //
// ./src/pages/Sellpoint/Post/script.js